import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getOrganizationsLinks } from '@components/navigation/constants/organizations'

import i18n from '@src/config/i18n'

import MobileMenuContainer from '../MobileMenuContainer'

type Props = {
  open: boolean
  onClose: () => void
}

export default function OrganizationsMobileTabMenu({ open, onClose }: Props) {
  const { t } = useTranslation('revamp')

  const organizationsLinks = getOrganizationsLinks(t, i18n.language)

  return (
    <MobileMenuContainer open={open}>
      <button onClick={onClose} className='mt-14 mb-12 text-xl hover:underline flex items-center'>
        <ChevronLeftIcon className='mr-2 h-4 w-4' />
        <span>{t('back')}</span>
      </button>
      <section className='flex flex-col gap-8'>
        {organizationsLinks.map((link) => (
          <a
            key={`mobile_organization_link_${link.title}`}
            href={link.link}
            className={'hover:underline flex items-center w-full leading-mid text-2xl'}
          >
            {link.title}
          </a>
        ))}
      </section>
    </MobileMenuContainer>
  )
}
